import { AaasModalNames } from '@va/aaas/shared/constants';
import { selectIntpWebsite } from '@va/aaas/shared/selectors';
import { closeModal } from '@va/dashboard/actions/ui';
import { isModalOpen } from '@va/dashboard/selectors/ui';
import { useTranslate } from '@va/localization';
import { Button, fontWeights, Heading4, Paragraph } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

export const AaasFreeTrialEndedModal_14Days_AccountSubscription_NoFreePlan = () => {
  const isOpen = useSelector((state) =>
    isModalOpen(state, AaasModalNames.freeTrialEnded_14days_accountSubscription_noFreePlan),
  );
  const translate = useTranslate();

  return (
    <ModalWrapper
      className='bg-black-lighter-84! backdrop-blur-2px'
      closeOnBackdropClick={false}
      isModalOpen={isOpen}
      closeModal={() => {}}
    >
      <div className='max-w-[45rem] sm:p-3 sm:pt-18px p-24px pt-6 overflow-hidden text-center'>
        <div>
          <Heading4 className='mb-6px' weight={fontWeights.semibold}>
            {translate('aaas.modals.trialEnded.accountSubscription.title')}
          </Heading4>
          <Paragraph className='mb-3' variant='display' variantSize='regular' weight={fontWeights.semibold}>
            {translate('aaas.modals.trialEnded.accountSubscription.subtitle')}
          </Paragraph>

          <Paragraph weight={fontWeights.semibold}>
            {translate('aaas.modals.trialEnded.accountSubscription.line1')}
          </Paragraph>
        </div>

        <AaasSubscriptionEndedActionButtons
          modalName={AaasModalNames.freeTrialEnded_14days_accountSubscription_noFreePlan}
        />
      </div>
    </ModalWrapper>
  );
};

export const AaasSubscriptionEndedActionButtons = ({ modalName }: { modalName: string }) => {
  const translate = useTranslate();
  const intpWebsiteInfo = useSelector(selectIntpWebsite);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className='flex gap-3 mt-18px'>
      <Button
        className='flex-1'
        color='secondary'
        text={translate('aaas.modals.trialEnded.accountSubscription.removeApp')}
        onClick={() => {
          window.parent?.postMessage(
            {
              data: {
                intpId: intpWebsiteInfo?.intpId,
                intpCustomerId: intpWebsiteInfo?.intpCustomerId,
              },
              type: 'remove_analytics_clicked',
            },
            '*',
          );
        }}
      />
      <Button
        className='flex-1'
        color='primary'
        text={translate('aaas.modals.trialEnded.accountSubscription.upgrade')}
        onClick={() => {
          history.push('/upgrade');
          dispatch(closeModal(modalName));
        }}
      />
    </div>
  );
};
